import type { TLiquiditySource } from 'shared/map-search/types/liquiditySource';

import type { TFeature } from '../../types/map';
import type { IConfig } from '@cian/config/shared';
import type { TDevice } from '@cian/utils';

type TGetLiquiditySourceParams = {
  deviceType: TDevice;
  config: IConfig;
  feature: TFeature;
};

export function getLiquiditySourceParam(params: TGetLiquiditySourceParams) {
  const { deviceType, config, feature } = params;
  /**
   * @todo: удалить в CD-260062
   */
  const isEnabled = !!config.get<boolean>('auction.cpcEnabled');

  if (!isEnabled) {
    return '';
  }

  const isMobile = deviceType !== 'desktop';
  const isPulsed = !!feature.properties?.isPulsedGlow;

  const liquiditySourceBase: TLiquiditySource = isMobile ? 'mobile-web_serp_map' : 'web_serp_map';
  const liquiditySource: TLiquiditySource = isPulsed ? `${liquiditySourceBase}_pulsed` : liquiditySourceBase;

  return `&liquiditySource=${encodeURIComponent(liquiditySource)}`;
}
